module.exports = __webpack_public_path__ + "static/img/help_09study_05.bdb7245.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_09study_05.png
// module id = 709
// module chunks = 140